'use strict';

module.exports = Object.freeze({
  email: 'Email',
  firstname: 'First Name',
  lastname: 'Surname',
  salutation: 'Salutation',
  birthdate: 'Birthdate',
  gender: 'Gender',
  mailingstreet: 'Street',
  mailingcity: 'City',
  mailingstate: 'State / Province / County',
  mailingpostalcode: 'Postcode / Zip code',
  mailingcountry: 'Country',
  homephone: 'Home Phone Number (Land Line)',
  mobilephone: 'Mobile Phone Number',
  faxnumber: 'Fax Number',
  twitter: 'Twitter Handle',
  linkedin: 'Linkedin Url',
  google: 'Google Email',
  instagram: 'Instagram Handle',
  facebook: 'Facebook Url',
  businessname: 'Business Name',
  businessindustry: 'Business Industry',
  title: 'Business Job Title',
  businessstreet: 'Business Street',
  businesscity: 'Business City',
  businesscountry: 'Business Country',
  businesspostalcode: 'Business Postcode / Zip code',
  businessphone: 'Business Phone Number',
});
